enum CompetitiveInsightsTabTypeEnum {
  NetworkSelection = "Network Selection",
  NetworkComparison = "Network Comparison",
  Manage = "Manage",
}

export { CompetitiveInsightsTabTypeEnum };
